import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { CultureService } from '@app/core/services/system-language/culture.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { Culture } from '@app/shared/models/system-language/culture.model';
import moment from 'moment';
import { finalize } from 'rxjs/operators';
import { LookupSubmit, TableListFieldOptionSubmit } from '../../models/lookup.model';
import { LookupService } from '../../services/lookup.service';

@Component({
  selector: 'app-add-single-value',
  templateUrl: './add-single-value.component.html',
  styleUrls: ['./add-single-value.component.scss']
})
export class AddSingleValueComponent implements OnInit {
  @Input() listGroup: string;
  @Output() saveComplete = new EventEmitter<boolean>();
  @Output() close = new EventEmitter<boolean>();
  formId: string = "frm_YbRoRaajlDxkFh";
  formData = {
    text: [],
    prioritize: false,
    startDate: moment().subtract('1', 'day').format(),
    endDate: null
  }
  getFormData: boolean = false;
  formValid: boolean = false;
  formPristine: boolean;

  constructor(
    private snackbarService: SnackbarService,
    private lookupService: LookupService,
    private overlayService: OverlayService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
  }

  emitClose() {
    this.close.emit(true);
  }

  formDataEmitted(formData) {
    this.save(formData);
  }

  formPristineEmitted(formPristine: boolean) {
    this.formPristine = formPristine;
  }

  formStatusUpdated(formValid) {
    this.formValid = formValid;
  }

  save(formData) {
    let tableListFieldOptionSubmit: TableListFieldOptionSubmit = {
      asOf: moment().format(),
      changeReason: '',
      changeReasonComments: '',
      id: '',
      prioritize: formData.prioritize,
      startDate: formData.startDate,
      endDate: formData.endDate,
      text: formData.text
    }

    this.overlayService.show();

    this.lookupService.addNewTableListFieldOption(this.listGroup, tableListFieldOptionSubmit)
    .pipe(
      finalize(() => this.overlayService.hide())
    )
    .subscribe(
      (res) => {
        this.saveComplete.emit(true);
        this.snackbarService.openSnackBar(`${this.translate.instant('SavedSuccessfully')}`, 'clear', 'success');
      },
      err => {
        this.snackbarService.openSnackBar(err, 'clear', 'warn');
      }
    );
  }
}
